import { useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

export function AdvertiserSignupDialog({ open, onClose, slug }) {
  const [form, setForm] = useState({ business_name: "", name: "", email: "", phone: "", message: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("submitting");
    setError("");
    try {
      await api.post(`/public/listing/${slug}/advertiser-signup-inquiry`, form);
      setState("success");
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong — please try again.");
      setState("idle");
    }
  };

  const close = () => { onClose(); setTimeout(() => { setState("idle"); setForm({ business_name: "", name: "", email: "", phone: "", message: "" }); }, 200); };

  return (
    <Dialog open={open} onOpenChange={(next) => !next && close()}>
      <DialogContent data-testid="advertiser-signup-dialog" className="bg-white border border-[#E7E4DE] rounded-2xl max-w-md">
        {state === "success" ? (
          <div className="py-6 text-center" data-testid="advertiser-signup-success">
            <div className="mx-auto h-12 w-12 rounded-full bg-[#C7A361]/15 grid place-items-center"><Check size={22} className="text-[#C7A361]" /></div>
            <h3 className="mt-4 font-serif-display text-xl text-[#202833]">Thanks for reaching out</h3>
            <p className="mt-2 text-sm text-[#667085]">The listing agent will follow up about advertising on this property website.</p>
            <Button data-testid="advertiser-signup-done" onClick={close} className="mt-6 rounded-full bg-[#C7A361] text-[#111820] hover:brightness-95">Done</Button>
          </div>
        ) : (
          <>
            <DialogHeader><DialogTitle className="font-serif-display text-xl font-normal text-[#202833]">Advertise on This Property Website</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-3 mt-1">
              <div><Label className="text-xs text-[#667085]">Business name</Label><Input data-testid="advertiser-signup-business" required value={form.business_name} onChange={(e) => setForm({ ...form, business_name: e.target.value })} className="mt-1.5 rounded-lg border-[#E7E4DE]" /></div>
              <div><Label className="text-xs text-[#667085]">Your name</Label><Input data-testid="advertiser-signup-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5 rounded-lg border-[#E7E4DE]" /></div>
              <div><Label className="text-xs text-[#667085]">Email</Label><Input data-testid="advertiser-signup-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 rounded-lg border-[#E7E4DE]" /></div>
              <div><Label className="text-xs text-[#667085]">Phone (optional)</Label><Input data-testid="advertiser-signup-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1.5 rounded-lg border-[#E7E4DE]" /></div>
              <div><Label className="text-xs text-[#667085]">Message</Label><Textarea data-testid="advertiser-signup-message" rows={3} placeholder="Tell us about your business" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1.5 rounded-lg border-[#E7E4DE]" /></div>
              {error && <p data-testid="advertiser-signup-error" className="text-xs text-red-600">{error}</p>}
              <Button data-testid="advertiser-signup-submit" type="submit" disabled={state === "submitting"} className="w-full rounded-full bg-[#C7A361] text-[#111820] hover:brightness-95 font-medium">{state === "submitting" ? "Sending…" : "Submit Inquiry"}</Button>
            </form>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
